import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { UiPageHeaderComponent } from '@markant-platform/shared/ui-components';
import { OrganizationContactStore } from './store/organization-contact.store';
import {
  OrganizationContactItemComponent,
  OrganizationContactItemSkeletonComponent,
  OrganizationDataComponent,
  OrganizationDataSkeletonComponent,
} from '@markant-platform/organization/ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'markant-platform-feature-organization-contact',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoPipe,
    UiPageHeaderComponent,
    OrganizationContactItemComponent,
    OrganizationContactItemSkeletonComponent,
    OrganizationDataComponent,
    OrganizationDataSkeletonComponent,
  ],
  templateUrl: './feature-organization-contact.component.html',
  styleUrl: './feature-organization-contact.component.scss',
  providers: [OrganizationContactStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureOrganizationContactComponent implements OnInit {
  private readonly translocoService = inject(TranslocoService);
  private readonly destroyRef = inject(DestroyRef);
  readonly store = inject(OrganizationContactStore);

  readonly CONTACTS_SKELETON = [1, 2, 3];

  ngOnInit(): void {
    this.translocoService.langChanges$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(_ => {
      this.store.getOrganizationData();
    });
  }
}
